import React from 'react';
import useRafState from '../useRafState';

const isClient = typeof window === 'object';

const useWindowScroll = () => {
    const [state, setState] = useRafState({
        x: isClient ? window.pageXOffset : 0,
        y: isClient ? window.pageYOffset : 0,
    });

    React.useEffect(() => {
        const handler = () => {
            setState({
                x: window.pageXOffset,
                y: window.pageYOffset,
            });
        };

        window.addEventListener('scroll', handler, {
            capture: false,
            passive: true,
        });

        return () => window.removeEventListener('scroll', handler);
    }, [setState]);

    return state;
};

export default useWindowScroll;
